import { FC, useState } from "react";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { Tab, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { CarbonSnapResultsResponse } from "../../../../../../datasources/carbonsnap/io/response";
import ArcTab from "./ArcTab";
import CountryTab from "./CountryTab";
import VehicleTab from "./VehicleTab";

interface Props {
	arcDetails: CarbonSnapResultsResponse["arcDetails"];
	countryDetails: CarbonSnapResultsResponse["countryDetails"];
	vehicleDetails: CarbonSnapResultsResponse["vehicleDetails"];
	route: CarbonSnapResultsResponse["route"];
}

const EmissionDetailsSection: FC<Props> = ({ arcDetails, countryDetails, vehicleDetails, route }) => {
	const { t } = useTranslation("feature.carbonsnap");
	const [value, setValue] = useState<"arcs" | "countries" | "vehicles">("arcs");

	const handleChange = (event: React.SyntheticEvent, newValue: "arcs" | "countries" | "vehicles") => {
		setValue(newValue);
	};

	return (
		<div>
			<Typography variant="h6" sx={{ mb: 2 }}>
				{t("results/details/title")}
			</Typography>
			<TabContext value={value}>
				<TabList onChange={handleChange} aria-label="emission details tabs">
					<Tab label={t("results/details/tab/arcs") || "Archi"} value="arcs" sx={{ textTransform: "uppercase" }} />
					<Tab
						label={t("results/details/tab/countries") || "Nazioni"}
						value="countries"
						sx={{ textTransform: "uppercase" }}
					/>
					<Tab
						label={t("results/details/tab/vehicles") || "Veicoli"}
						value="vehicles"
						sx={{ textTransform: "uppercase" }}
					/>
				</TabList>
				<TabPanel value="arcs" sx={{ padding: 0, width: "100%", mt: 2 }}>
					<ArcTab arcDetails={arcDetails} route={route} />
				</TabPanel>
				<TabPanel value="countries" sx={{ padding: 0, width: "100%", mt: 2 }}>
					<CountryTab countryDetails={countryDetails} />
				</TabPanel>
				<TabPanel value="vehicles" sx={{ padding: 0, width: "100%", mt: 2 }}>
					<VehicleTab vehicleDetails={vehicleDetails} />
				</TabPanel>
			</TabContext>
		</div>
	);
};

export default EmissionDetailsSection;
